import React from 'react';

const MobileWarning = () => (
	<div className="mobile-warning">
		<p>Sorry, the mobile version is coming soon, please use a tablet or a computer</p>
	</div>
);

export default MobileWarning;